import { render, staticRenderFns } from "./Profits.vue?vue&type=template&id=fcf95a4e&scoped=true&"
import script from "./Profits.vue?vue&type=script&lang=js&"
export * from "./Profits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf95a4e",
  null
  
)

export default component.exports